import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-21c30859"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card-container",
  "data-test": "assess-home-insights-card"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "intro-header" }, "Introducing", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "GyreInsights: Solo Report", -1))
const _hoisted_4 = { class: "flex-content" }
const _hoisted_5 = { class: "flex-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Our Jyranians will:"),
  /*#__PURE__*/_createElementVNode("ul", { class: "bullet-points" }, [
    /*#__PURE__*/_createElementVNode("li", null, "Help you think about yourself in terms of your Best-fit Leader types"),
    /*#__PURE__*/_createElementVNode("li", null, " Guide you through their insights about your personal strengths, considering your contribution to your team and your ideal roles. "),
    /*#__PURE__*/_createElementVNode("li", null, "Help you think about what to develop - close a gap or build on a strength")
  ])
], -1))

import LottieJyranianWithText from "./lottie/lottie-jyranian-with-text.vue";

const GYREINSIGHTS_LINK = "/resources/session/gyreinsights-your-solo-report";

export default /*#__PURE__*/_defineComponent({
  __name: 'jyre-insights-card',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", { class: "intro-text" }, [
      _createTextVNode(" The "),
      _createElementVNode("a", { href: GYREINSIGHTS_LINK }, "GyreInsights: Solo report"),
      _createTextVNode(" resource will provide you with real-time observations and suggestions based on your strength mapping and Solo report, saving you the time and effort of interpreting it yourself! ")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(LottieJyranianWithText, { width: "100%" })
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", { class: "card-btn-container" }, [
      _createElementVNode("a", {
        href: GYREINSIGHTS_LINK,
        class: "btn btn-primary-forward-bold",
        "data-test": "assess-home-insights-link"
      }, "Try it out!")
    ])
  ]))
}
}

})